import { AlertTriangle, Compass, LoaderCircle, RotateCcw } from "lucide-react";
import { Button } from "./Button";

export function LoadingState({ label = "Preparing your next escape…" }: { label?: string }) {
  return (
    <div className="state-card" role="status" aria-live="polite">
      <LoaderCircle className="state-card__spinner" aria-hidden="true" />
      <h3>{label}</h3>
      <p>One moment while we gather the best options for you.</p>
    </div>
  );
}

export function EmptyState({
  title = "No journeys match just yet",
  description = "Try widening your filters or explore all available packages.",
  onReset,
}: {
  title?: string;
  description?: string;
  onReset?: () => void;
}) {
  return (
    <div className="state-card">
      <Compass aria-hidden="true" />
      <h3>{title}</h3>
      <p>{description}</p>
      {onReset && <Button icon={<RotateCcw size={17} />} onClick={onReset}>Reset filters</Button>}
    </div>
  );
}

export function ErrorState({
  onRetry,
  title = "We hit a little turbulence",
}: {
  onRetry?: () => void;
  title?: string;
}) {
  return (
    <div className="state-card state-card--error" role="alert">
      <AlertTriangle aria-hidden="true" />
      <h3>{title}</h3>
      <p>We could not load this right now. Your travel plans are safe—please try again.</p>
      {onRetry && <Button onClick={onRetry}>Try again</Button>}
    </div>
  );
}

